import {
  GET_REPORTS_DATA,
  GET_REPORTS_LIST,
  EMPTY_REPORT_DATA
} from "../../constants/types";

export const INITIAL_STATE = {
  reportList: {},
  reportData: {}
  // reportData: []
}


export const Reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_REPORTS_LIST:
      return { ...state, reportList: action.payload };
    case GET_REPORTS_DATA:
      return { ...state, reportData: action.payload };
    case EMPTY_REPORT_DATA :
      return { ...state, reportData:INITIAL_STATE.reportData};

      return INITIAL_STATE;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/reports/ReportsReducers.js